import React from "react";
import dimIcon from "../../../../assets/dimand.svg";
import downloadIcon from "../../../../assets/download_icon.svg";
import eyeIcon from "../../../../assets/eye_icon.svg";
import resultimg from "../../../../assets/result_img.png";
import { Header } from "../../../../components/header/Header";
import {getFileUrl } from "../../../../utils/GetAuthUser";
import { getRole } from "../../../../utils/GetRole";

export const SketchResult = ({ result }) => {
 

  const fileUrl = getFileUrl();
  const resultImage = result ? `${fileUrl}${result}` : resultimg;
  const role=getRole()

  const API_BASE = process.env.REACT_APP_API_URL;


  const handleDownload = () => {
  const fileName = result ? result.split("/").pop() : "contest-result.png";
  const link = document.createElement("a");

  

   link.href = `${API_BASE}/download/${fileName}`;
  link.setAttribute("download", fileName);

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};



  // 👁 Keep your original view function
  const handleView = () => {
    const link = document.createElement("a");
    link.href = resultImage;
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <header className="fixed top-0 left-0 md:left-[205px] md:w-[calc(100%-205px)] z-40 bg-white w-full h-14 md:h-[84px] flex items-center justify-center px-4 sm:px-[51px] border-b border-border_color ">
        <Header title={"Contest"} showBack={true} />
      </header>

      <div className="w-full bg-[#F7F7F7]">
        <div className="w-full mx-auto flex flex-col items-center justify-center gap-10 lg:flex-row ">
          <div className="w-full  h-full flex flex-col  gap-5">
                  {role=='user'?
            <div className="w-full sm:h-12 flex items-center justify-between bg-primary text-white p-2 sm:p-4 border border-border_color rounded-[10px] gap-2">
       
              <div className="flex items-center gap-3">
                <img src={dimIcon} alt="" />
                <p className="font-medium text-[13px] font-grotesk ">
                  Want to sketch more images? Please Upgrade your Plan
                </p>
              </div>
            
              <div>

                <button className="px-[14px] py-[7px] bg-white rounded-xl text-primary font-medium text-[11px] font-grotesk">
                  Upgrade
                </button>
              </div>
            </div>
:''}
            <div className={`w-full ${role == 'user' ? 'h-[513px]' : 'h-[540px]'} flex flex-col items-start rounded-[14px] overflow-hidden relative`}>
              <img
                src={resultImage}
                alt="Contest Result"
                className="w-full h-full object-cover"
              />

              <div className="absolute bottom-4 right-4 flex items-center gap-2">
          {role=='user'?
                <button
                  onClick={handleDownload}
                  className="bg-secondary h-9 p-[10px] rounded-lg"
                >
                  <img src={downloadIcon} alt="Download" />
                </button>
:''}
                {/* 👁 View Button */}
                <button
                  onClick={handleView}
                  className="bg-secondary h-9 p-[10px] rounded-lg"
                >
                  <img src={eyeIcon} alt="View" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
